import { addField, addGroup } from 'live/widgets/helpers'
import DataService from 'live/services/charts/data'
import { BoxplotEvent, BoxplotState } from './types'
import { getMetasValuesFromEvent } from 'plugin-live-exploratory-viz/src/utils'

export function startQuery(actions: StartFlowMessage, state: BoxplotState): BoxplotState {
    if (!actions?.events) {
        return state
    }

    const { select, group } = actions.events

    const newState = {
        fields: [],
        groups: []
    }

    select?.forEach(function (field) {
        addField(newState.fields, field)
    })
    group?.forEach(function (field) {
        addGroup(newState.groups, field)
    })

    const supportedMetas = ['color', 'lineColor']

    const metas = getMetasValuesFromEvent(actions.events.info, supportedMetas)

    return {
        metas,
        ...state,
        ...newState
    }
}

export function getInitialState(): BoxplotState {
    return {
        historyEnded: false,
        fields: [],
        data: []
    }
}

export function accEvents(action: EventFlowMessage<LiveEvent<BoxplotEvent>>, state: BoxplotState): BoxplotState {
    const allEvents = []
    const allCategories = []

    state.fields.forEach(field => {
        action.events.forEach(event => {
            if (!Array.isArray(event[field])) return

            const [min, q1, median, q3, max, mean] = event[field]
            let category = DataService.makeGroupValue(state.groups, event, ', ')

            if (!category) category = field
            if (allCategories.includes(category) === false) allCategories.push(category)

            const supportedMetas = ['__color', '__lineColor']

            const metasfromEvent = getMetasValuesFromEvent<LiveEvent<BoxplotEvent>>(event, supportedMetas, true)

            const metas = {
                ...state.metas,
                ...metasfromEvent
            }

            const color = metas.color || null
            const lineColor = metas.lineColor || null

            const object: BoxplotEvent = {
                name: category,
                max,
                q3,
                median,
                mean,
                interQuantileRange: q3 - q1,
                q1,
                min,
                color,
                lineColor
            }
            allEvents.push(object)
        })
    })

    const newState = { ...state, data: allEvents, categories: allCategories }

    return newState
}

export function getEndState(state: BoxplotState): BoxplotState {
    return {
        ...state,
        historyEnded: true
    }
}
